import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import api from '../lib/api';
import { resumePendingCheckout } from '../lib/pendingPlan';
import { useAuth } from '../context/AuthContext';
import { useLang, tx } from '../i18n/LanguageContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const { refreshUser } = useAuth();
  const { lang } = useLang();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const params = new URLSearchParams(window.location.search);
    const code = params.get('code');
    const state = params.get('state');
    if (!code || !state) { navigate('/login', { replace: true }); return; }
    (async () => {
      try {
        const { data } = await api.post('/auth/google/callback', { code, state, redirect_uri: window.location.origin + '/auth/google' });
        await refreshUser();
        if (await resumePendingCheckout()) return;
        navigate(data?.role === 'admin' ? '/admin' : '/', { replace: true });
      } catch (e) {
        toast.error(tx(lang, 'فشل تسجيل الدخول بجوجل، حاول مرة أخرى', 'Google sign-in failed, please try again'));
        navigate('/login', { replace: true });
      }
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div data-testid="google-callback" className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-700">
      <div className="text-center">
        <div className="w-12 h-12 border-2 border-blue-500 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <div>{tx(lang, 'جارٍ تسجيل الدخول...', 'Signing you in...')}</div>
      </div>
    </div>
  );
}
